var AddContactRequestModel = /** @class */ (function () {
    function AddContactRequestModel() {
    }
    return AddContactRequestModel;
}());
export { AddContactRequestModel };
